<template>
    <div id="userManager">
        <div id="switchStatusUsers">
            <input type="radio" id="active" value="0" v-model="selected">
            <label for="active" style="margin-right: 15px"> Comptes activés </label>
            <input type="radio" id="unActive" value="1" v-model="selected">
            <label for="unActive"> Comptes désactivés </label>
        </div>

        <div v-if="selected == 0" id="activeUserManager">

            <span class="userMenu">
                <label for="selectUser"> Utilisateurs </label> <br>
                <select id="selectUser" data-live-search="true" size="35" v-model="activeUserSelected">
                    <option v-for="(user, index) in activeUsers" :key="user.id" v-bind:value="index"> {{ user.login }} </option>
                </select>
                <div v-if="!newUserCreation" class="btnNew btn btn-outline-success" v-on:click="newUser">Nouvel utilisateur</div>
            </span>
            <div class="userInfos" v-if="activeUsers[activeUserSelected]" id="projectList">
                <table>
                    <thead>
                        <th scope="col">Informations</th>
                    </thead>
                    <tbody>
                        <tr v-if="newUserCreation">
                            <td class="title"> Login <span v-if="newUserCreation">*</span> </td>
                        </tr>
                        <tr v-if="newUserCreation">
                            <td> <input id="login" placeholder="Login" @change="updateField()" v-model.lazy="activeUsers[activeUserSelected].login" autocomplete="new-password" /> </td>
                        </tr>
                        <tr>
                            <td class="title"> Mot de passe <span v-if="newUserCreation">*</span> </td>
                        </tr>
                        <tr>
                            <td>
                                <input id="password" placeholder="Mot de passe" @change="updateField(true)" v-model.lazy="activeUsers[activeUserSelected].password" autocomplete="new-password" />
                            </td>
                        </tr>
                        <tr>
                            <td class="title"> Nom </td>
                        </tr>
                        <tr>
                            <td> <input id="name" placeholder="Nom " @change="updateField()" v-model.lazy="activeUsers[activeUserSelected].name" /> </td>
                        </tr>
                        <tr>
                            <td class="title"> Rôle </td>
                        </tr>
                        <tr>
                            <td> <select v-model="activeUsers[activeUserSelected].role" @change="updateField()">
                                    <option value="1024"> Administrateur</option>
                                    <option value="324"> Responsable</option>
                                    <option value="68"> Coresponsable</option>
                                    <option value="4"> Développeur</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td class="title"> Tarif horaire <span v-if="newUserCreation">*</span> </td>
                        </tr>
                        <tr>
                            <td> <input type="number" id="Tarif" placeholder="Tarif " @change="updateField()" v-model.lazy="activeUsers[activeUserSelected].rate" /> </td>
                        </tr>
                        <tr>
                            <td class="title"> Email </td>
                        </tr>
                        <tr>
                            <td> <input id="email" placeholder="Email " @change="updateField()" v-model.lazy="activeUsers[activeUserSelected].email" /> </td>
                        </tr>
                        <tr>
                            <td class="title"> Status </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="btnDisable btn btn-outline-success" v-on:click="toggleUserStatus">
                                    Désactiver
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="!newUserCreation" class="tableProject">
                    <table>
                        <thead>
                            <th scope="col">Projets</th>
                        </thead>
                        <tbody class="projects">
                            <tr v-for="project in activeUsers[activeUserSelected].projects" :key="project.id" class="lineHover">
                                <td v-if="project.status == 1" class="projectLine">
                                    {{project.name}}
                                </td>
                                <td v-if="project.status == 0" class="projectLine disable">
                                    {{project.name}}
                                </td>
                                <td id="unbind">
                                    <b-icon v-on:click="unbindProject(project)" icon="x-circle-fill" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <v-select label="name" :options="notBindProjects" :value="addProject" @input="project => bindProject(project)">
                        <span slot="no-options">
                            Tous les projets sont associés
                        </span>
                    </v-select>
                </div>
            </div>
        </div>

        <div v-if="selected == 1" id="unActiveUserManager">
            <span class="userMenu">
                <label for="selectUnActiveUser"> Utilisateurs inactif </label> <br>
                <select id="selectUnActiveUser" data-live-search="true" size="15" v-model="unActiveUserSelected">
                    <option v-for="(user, index) in unActiveUsers" :key="user.id" v-bind:value="index"> {{ user.login }} </option>
                </select>
            </span>
            <div class="userInfos" v-if="unActiveUsers[unActiveUserSelected]" id="projectList">
                <table>
                    <thead>
                        <th scope="col">Informations</th>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="title"> Nom </td>
                        </tr>
                        <tr>
                            <td> {{unActiveUsers[unActiveUserSelected].name}} </td>
                        </tr>
                        <tr>
                            <td class="title"> Email </td>
                        </tr>
                        <tr>
                            <td> {{unActiveUsers[unActiveUserSelected].email}} </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="btnDisable btn btn-outline-success" v-on:click="toggleUserStatus">
                                    Activer
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    const axios = require('axios');

    export default {
        name: "User",
        data() {
            return {
                users: [],
                activeUsers: [],
                unActiveUsers: [],
                activeUserSelected: 0,
                unActiveUserSelected: 0,
                notBindProjects: [],
                addProject: '',
                selected: 0,
                newUserCreation: false,
                cancel: false,
            }
        },
        created: function() {
            axios.get(this.$store.state.apiUrl + 'user/usersWithProject', {
                    params: {
                        login: localStorage.login,
                        password: localStorage.pass
                    }
                })
                .then(response => (this.organiseData(response.data)))
                .catch((e) => {
                    this.printError(e);
                });
        },
        methods: {
            organiseData: function(data) {
                var tmpData = [];
                if (data) {
                    data.forEach(value => {
                        var index = tmpData.findIndex(user => user.id == value.id);
                        if (index < 0) {
                            index = tmpData.push(value) - 1;
                            tmpData[index]['projects'] = [];
                            if (value.project_id) {
                                tmpData[index].projects = [{
                                    id: value.project_id,
                                    name: value.project_name,
                                    status: value.project_status
                                }];
                            }
                        } else {
                            tmpData[index].projects.push({
                                id: value.project_id,
                                name: value.project_name,
                                status: value.project_status
                            });
                        }
                    });
                }
                this.userSelected = 0;
                this.users = tmpData;
            },
            newUser: function() {
                this.newUserCreation = true;
                var newUser = {
                    id: null,
                    login: null,

                    name: '',
                    email: '',
                    rate: 0,
                    role: 4,
                    status: 1,
                };
                if (this.activeUsers) {
                    this.activeUserSelected = this.activeUsers.push(newUser) - 1;
                } else {
                    this.activeUsers = [newUser];
                    this.activeUserSelected = 0;
                }
            },
            updateField: function(editPassword) {
                var user = this.activeUsers[this.activeUserSelected];
                if (!this.newUserCreation) {
                    var data = {
                        login: '',
                        name: user.name,
                        email: user.email,
                        rate: user.rate,
                        role: user.role,
                        password: '',
                    };
                    if (editPassword) {
                        data.password = user.password;
                    }
                    axios.put(this.$store.state.apiUrl + 'user/update/' + user.id, data, {
                            params: {
                                login: localStorage.login,
                                password: localStorage.pass
                            }
                        })
                        .then(this.toast("Utilisateur mis à jours", 3000))
                        .catch((e) => {
                            this.printError(e);
                        });
                } else {
                    if (user.login && user.password && user.rate) {
                        var tmpData = new FormData();
                        for (var field in user) {
                            tmpData.append(field, user[field]);
                        }

                        axios.post(this.$store.state.apiUrl + 'user/new', tmpData, {
                                params: {
                                    login: localStorage.login,
                                    password: localStorage.pass
                                }
                            })
                            .then(response => (this.checkNewUser(response, user)))
                            .catch((e) => {
                                this.printError(e);
                            });
                    }
                }

            },
            checkNewUser: function(response, user) {
                if (response.status == 200) {
                    user.id = response.data.id;
                    user.projects = [];
                    this.newUserCreation = false;
                    this.cancel = false;
                } else {
                    var errors = response.data;
                    this.toast(errors["userLogin"], 5000);
                }
            },
            bindProject: function(project) {
                var user = this.activeUsers[this.activeUserSelected];
                this.removeNotBindProject(project);

                var data = {
                    userId: user.id,
                    projectId: project.id,
                    rate: user.rate
                }

                var tmpData = new FormData();
                for (var field in data) {
                    tmpData.append(field, data[field]);
                }
                axios.post(this.$store.state.apiUrl + 'userProjectBind/new', tmpData, {
                        params: {
                            login: localStorage.login,
                            password: localStorage.pass
                        }
                    })
                    .then(response => (this.checkBindProject(response, project)))
                    .catch((e) => {
                        this.printError(e);
                    });

            },
            checkBindProject: function(response, project) {
                if (response.status == 200) {
                    this.addBindProject(project);
                }
            },
            addBindProject: function(project) {
                if (!this.activeUsers[this.activeUserSelected].projects) {
                    this.activeUsers[this.activeUserSelected].projects = [];
                }
                this.activeUsers[this.activeUserSelected].projects.push({
                    id: project.id,
                    name: project.name,
                    status: project.status
                });
            },
            removeBindProject: function(project) {
                this.activeUsers[this.activeUserSelected].projects.forEach((current, index) => {
                    if (current.id == project.id) {
                        this.activeUsers[this.activeUserSelected].projects.splice(index, 1);
                    }
                });
            },
            addNotBindProject: function(project) {
                this.notBindProjects.push(project);
            },
            removeNotBindProject: function(project) {
                this.notBindProjects.forEach((current, index) => {
                    if (current.id == project.id) {
                        this.notBindProjects.splice(index, 1);
                    }
                });
            },
            unbindProject: function(project) {
                var user = this.activeUsers[this.activeUserSelected];
                this.removeBindProject(project);
                axios.delete(this.$store.state.apiUrl + "userProjectBind/delete/" + user.id + "/" + project.id, {
                        params: {
                            login: localStorage.login,
                            password: localStorage.pass
                        }
                    })
                    .then(response => this.checkUnbindProject(response, project))
                    .catch((e) => {
                        this.printError(e);
                    });

            },
            checkUnbindProject: function(response, project) {
                if (response.status == 200) {
                    this.addNotBindProject(project);

                } else {
                    this.addBindProject(project);
                }
            },
            toggleUserStatus: function() {
                var user;
                if (this.selected == 0) {
                    user = this.activeUsers[this.activeUserSelected];
                } else {
                    user = this.unActiveUsers[this.unActiveUserSelected];

                }
                axios.put(this.$store.state.apiUrl + 'user/toggleStatus/' + user.id, null, {
                        params: {
                            login: localStorage.login,
                            password: localStorage.pass
                        }
                    })
                    .then(response => (this.checkToggleUserStatus(response, user)))
                    .catch((e) => {
                        this.printError(e);
                    });
            },
            checkToggleUserStatus: function(response, user) {
                if (response.status == 200) {
                    user.status = !user.status;
                    this.filterUsers();
                }
            },
            filterUsers: function() {
                this.activeUsers = this.users.filter(user => user.status == 1);
                this.unActiveUsers = this.users.filter(user => user.status != 1);
                this.getNotBindProject();
            },
            getNotBindProject: function() {
                if (!this.newUserCreation) {
                    var user = this.activeUsers[this.activeUserSelected]

                    axios.get(this.$store.state.apiUrl + 'project/user/notAssigned/' + user.id, {
                        params: {
                            login: localStorage.login,
                            password: localStorage.pass
                        }
                    })
                    .then(response => (this.notBindProjects = response.data))
                    .catch((e) => {
                        this.printError(e);
                    });
                }
            },
            toast: function(message, time) {
                this.$toasted.show(message, {
                    position: 'bottom-center',
                    theme: 'outline'
                }).goAway(time);
            },
            printError: function(e) {
                console.log(e);
                this.$toasted.show("Erreur de connexion, veuillez essayer ultérieurement", {
                    position: 'bottom-center',
                    theme: 'outline'
                }).goAway(2000);
            }
        },
        watch: {
            users: function() {
                this.filterUsers();
            },
            activeUserSelected: function() {
                if (this.cancel) {
                    this.newUserCreation = false;
                    this.cancel = false;
                    this.activeUsers.pop();
                }

                if (!this.newUserCreation) {
                    this.getNotBindProject();
                } else {
                    this.cancel = true;
                }
            }
        },
    };
</script>

<style scoped>
    #switchStatusUsers {
        text-align: left;
        margin-left: 1em;
        margin-top: 0.3em;
    }
    #switchStatusUsers input {
        margin-right: 0.3em;
    }

    #userManager {
        height: 100%;
        width: 100%;
        display: inline-block;
    }

    #activeUserManager,
    #unActiveUserManager {
        text-align: left;
        display: inline-block;
        width: 100%;
        height: 500px;
    }

    #selectUser,
    #selectUnActiveUser {
        width: 100%;
    }

    .userMenu {
        float: left;
        margin-left: 1em;
        display: inline-block;
        width: 18%;
    }

    .btnNew {
        width: 100%;
    }

    .userInfos {
        height: 100%;
    }

    .tableProject {
        display: inline-block;
    }

    .projects,
    .tableProject {
        width: 600px;
    }

    .projectLine {
        width: 560px;
    }

    .lineHover:hover {
        background-color: #c3e2f4
    }

    .userInfos>table,
    .tableProject {
        float: left;
        margin-left: 2em;
    }

    .projects {
        display: inline-block;
        overflow-y: scroll;
        height: max-content;
    }

    .disable {
        background-color: #ff5050a3;
        border-radius: 0.3em;
    }

    .title {
        font-weight: bold;
    }

    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        margin: 0;
    }

    #unbind {
        cursor: pointer;
    }

    @media screen and (max-width: 790px){
        .projects{
            width: auto;
        }
        .tableProject{
            width: 50%;
        }
    }
</style>